export default {
  model: [
    {
      label: 'Nome',
      field: 'name',
      type: 'text'
    },
    {
      label: 'Descrição',
      field: 'description',
      type: 'text'
    },
    {
      label: 'Preço',
      field: 'price',
      type: 'text'
    },
    {
      label: 'Período',
      field: 'period',
      type: 'text'
    },
    {
      label: 'Período',
      field: 'period_type',
      type: 'text'
    },
    {
      label: 'Revistas',
      field: 'magazines',
      type: 'array'
    },
    {
      label: 'Produtos',
      field: 'products',
      type: 'array'
    }
  ]
}